import { MaskReveal, Rise } from "@/components/site/Reveal";
import { ATMOSPHERE } from "@/lib/site";

export const Motorcycle = () => {
  return (
    <section
      data-testid="motorcycle-section"
      className="relative bg-bone-section text-ink overflow-hidden py-24 sm:py-36"
    >
      <div
        style={{ backgroundImage: `url(${ATMOSPHERE.highway})` }}
        className="absolute inset-0 mono opacity-[0.12] bg-cover bg-center scale-110"
        aria-hidden="true"
      />

      {/* slow marquee watermark */}
      <div className="relative z-10 mb-14 whitespace-nowrap" aria-hidden="true">
        <div className="inline-flex animate-marquee will-change-transform">
          {[0, 1].map((k) => (
            <span
              key={k}
              className="font-serif uppercase tracking-tight text-ink/[0.06] text-[18vw] leading-none pr-[6vw]"
            >
              Ride Like a Lady&nbsp;&nbsp;·&nbsp;&nbsp;Ride Like a Lady&nbsp;&nbsp;·&nbsp;&nbsp;
            </span>
          ))}
        </div>
      </div>

      <div className="relative z-10 mx-auto max-w-[1500px] px-6 sm:px-10 -mt-16 sm:-mt-24">
        <div className="max-w-4xl">
          <MaskReveal
            as="h2"
            lines={["THE MOTORCYCLE", "WAS THE BEGINNING."]}
            className="font-serif uppercase leading-[0.9] tracking-tight text-ink text-5xl sm:text-7xl lg:text-8xl"
            testId="motorcycle-title"
          />
          <Rise delay={0.2} className="mt-6">
            <p className="font-brush text-2xl sm:text-3xl text-rust">
              Freedom was the point.
            </p>
          </Rise>
          <Rise delay={0.3} className="mt-10 max-w-2xl space-y-5 font-sans text-base sm:text-lg leading-relaxed text-ink/75">
            <p>
              Motorcycling is part of Grace’s story, but it was never the
              destination. It was the first honest thing that proved a bigger
              truth. Movement changes you, risk teaches you, and the version of
              your life you’ve outgrown was never the only one available.
            </p>
            <p>
              What began as learning to ride became a way of refusing to shrink.
              Freedom, change, and trusting yourself before you have proof. That
              is what this is really about.
            </p>
          </Rise>
        </div>
      </div>
    </section>
  );
};
